import { render, staticRenderFns } from "./pageSearch.vue?vue&type=template&id=ba771f20&scoped=true"
import script from "./pageSearch.vue?vue&type=script&lang=js"
export * from "./pageSearch.vue?vue&type=script&lang=js"
import style0 from "./pageSearch.vue?vue&type=style&index=0&id=ba771f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba771f20",
  null
  
)

export default component.exports